import { render, staticRenderFns } from "./DeleteAllBlock.vue?vue&type=template&id=5e031960&scoped=true&"
import script from "./DeleteAllBlock.vue?vue&type=script&lang=js&"
export * from "./DeleteAllBlock.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAllBlock.vue?vue&type=style&index=0&id=5e031960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e031960",
  null
  
)

export default component.exports